module.exports = __webpack_public_path__ + "img/s5.a6bdda8f.png";